var PageOrder = (function ($) {

    PageOrder = function (options) {
        var that = this;

        that.class = {
            copy: 'js-copy',
            sticky_observer: 'js-sticky-observer',
            is_stick: 'is-stick',
            timelimit: 'js-timelimit',
            modal_tickets: 'js-modal-tickets',
            modal_receipt_details: 'js-modal-receipt-details',
            modal_svc_details: 'js-svs-details-modal',
            modal_svc_type_empty: 'js-svs-type-empty-modal',
            variant: 'js-variant',
            variant_direction_departure: 'js-variant-direction-departure',
            variant_direction_arrival: 'js-variant-direction-arrival',
            variant_localtime_disclaimer: 'js-drawer-localtime-disclaimer',
            variant_duration: 'js-duration',
            variant_segments_wrapper: 'js-segments-wrapper',
            variant_brand_info: 'js-brand-info',
            variant_brand_name: 'js-brand-name',
            drawer_segments_trigger: 'js-drawer-segments-trigger',
            fareremark_info: 'js-fareremark-info',
            form_receipt_send: 'js-receipt-send-form',
            button_receipt_send: 'js-button-receipt-send',
            exchange_cancel: 'js-exchange-cancel',
            email: 'js-email',
            loading: 'loading',
            confirmed_email: 'js-receipt-confirmed-email'
        }

        // DOM
        that.$wrapper = options['$wrapper'];

        // CONST
        that.order_hash = options['order_hash'];
        that.order_passenger_hash = options['order_passenger_hash'];
        that.status = options['status'];
        that.is_group = options['is_group'];
        that.timelimit = options['timelimit'];

        that.modals = options['modals'];

        // DYNAMIC VARS
        that.receipt_modal = null;

        // INIT
        that.init();
    };

    PageOrder.prototype.init = function () {
        var that = this;

        //
        that.initVariants();
        //
        $.sa.stickyObserver('.' + that.class.sticky_observer, that.class.is_stick);
        //
        that.__initTimelimit();
        //
        that.__initStatusChecker();
        // 
        that.__initTicketsModal();
        //
        that.__initSvcDetailsModal();
        //
        that.__initSvcTypeEmptyModal();
        //
        that.__initReceiptModal();
        //
        that.__initFareremark();
        //
        that.__initExchangeCancel();
    };

    PageOrder.prototype.initVariants = function () {
        var that = this,
            $variants = that.$wrapper.find('.' + that.class.variant);

        $.each($variants, function (i, order_variant) {
            var $variant = $(order_variant);

            that.orderVariant($variant);
        });
    };

    PageOrder.prototype.orderVariant = function ($variant) {
        var that = this;

        $variant.on('click', '.' + that.class.drawer_segments_trigger, function (e) {
            e.preventDefault();
            that.__drawerSegmentsCall($(this));
        });
    };

    PageOrder.prototype.__initFareremark = function () {
        var that = this;

        that.$wrapper.on('click', '.' + that.class.fareremark_info, function () {
            $.uiFareremark({
                order_hash: that.order_hash,
                order_passenger_hash: that.order_passenger_hash
            });
        });
    };

    PageOrder.prototype.__initExchangeCancel = function () {
        var that = this,
            href = $.sa.build_url('order/exchange/cancel'),
            data = {
                order_hash: that.order_hash
            },
            $exchange_cancel_button = that.$wrapper.find('.' + that.class.exchange_cancel),
            is_locked = false;

        $exchange_cancel_button.on('click', function (e) {
            e.preventDefault();

            if (is_locked) {
                return;
            }
            is_locked = true;

            $.sa.buttonLoading($exchange_cancel_button);
            $.post(href, data)
                .done(function (response) {
                    if (response.status === 'ok' &&
                        response.data && response.data.result === true
                    ) {
                        $.sa.content_router.reload();
                    }
                }).always(function () {
                    is_locked = false;
                    $.sa.buttonLoading($exchange_cancel_button, false);
                });
        });
    };

    PageOrder.prototype.__drawerSegmentsCall = function (trigger) {
        var that = this,
            $trigger = $(trigger),
            $variant = $trigger.parents('.' + that.class.variant),

            drawer_header = [
                $variant.find('.' + that.class.variant_direction_departure).text(),
                $variant.find('.' + that.class.variant_direction_arrival).text()
            ],
            variant_duration = [
                $variant.find('.' + that.class.variant_duration).data('travel-time'),
                $variant.find('.' + that.class.variant_duration).text()
            ],
            $drawer_content = $variant.find('.' + that.class.variant_segments_wrapper).clone();

        $drawer_content.append($variant.find('.' + that.class.variant_localtime_disclaimer).html());

        $.uiDrawer({
            position: 'right',
            custom_class: 'narrow variant-card no-radius drawer-segments',
            header_title: drawer_header.join(' — '),
            header_description: variant_duration.join(': '),
            content: $drawer_content.html()
        });
    };

    PageOrder.prototype.__initTimelimit = function () {
        var that = this,
            $timelimit = that.$wrapper.find('.' + that.class.timelimit),
            modal_title = $timelimit.data('expired-title'),
            modal_description = $timelimit.data('expired-description'),
            modal_link_url = $timelimit.data('expired-link-url'),
            modal_link_text = $timelimit.data('expired-link-text'),
            modal_icons = $timelimit.data('expired-icons');

        if ($timelimit.length) {
            new UITimelimit({
                $wrapper: $timelimit,
                timelimit: that.timelimit,
                no_units: true,
                onTimeLeft: function () {
                    $.uiModal({
                        header_icons: modal_icons,
                        header_title: modal_title,
                        custom_class: 'align-center',
                        remove_close_cross: true,
                        esc: false,
                        onBgClick: function (modal, event) {
                            event.preventDefault();
                            return false;
                        },
                        content: `${modal_description} <br><br> <a class="button large primary js-disable-router" href="${modal_link_url}">${modal_link_text}</a>`
                    });
                }
            });
        }
    };

    PageOrder.prototype.__initStatusChecker = function () {
        var that = this,
            statuses_checked = ['paid', 'issue_processing'];

        if (that.is_group || $.inArray(that.status, statuses_checked) === -1) {
            return;
        }

        var counter = 0,
            is_locked = false,
            timer = setInterval(function () {
                if (is_locked) {
                    return;
                }
                
                if (counter >= 200) {
                    clearInterval(timer);
                } else {
                    is_locked = true;
                    
                    var href = $.sa.build_url('order/status'),
                        data = {order_hash: that.order_hash};
                    
                    $.post(href, data, function (res) {
                        if (res && res.data && res.data.status && res.data.status) {
                            if (res.data.status !== that.status) {
                                clearInterval(timer);
                                $.sa.content_router.reload();
                            }
                        }
                        is_locked = false;
                    });
                    counter++;
                }
            }, 2500);
    };

    PageOrder.prototype.__initTicketsModal = function () {
        var that = this;

        that.$wrapper.on('click', '.' + that.class.modal_tickets, function (e) {
            e.preventDefault();

            that.__renderModal('tickets');
        });
    };
    
    PageOrder.prototype.__initSvcDetailsModal = function (){
        var that = this;
        
        that.$wrapper.on('click', '.' + that.class.modal_svc_details, function (e) {
            e.preventDefault();
            var type = $(this).data('type');
            that.__renderModal(type);
        });
    };
    
    PageOrder.prototype.__initSvcTypeEmptyModal = function (){
        var that = this;

        that.$wrapper.on('click', '.' + that.class.modal_svc_type_empty, function(event) {
            event.preventDefault();

            const type = $(this).data('type');

            that.__renderModal(type, {
                onOpen: function($wrapper) {
                    const $button = $wrapper.find('.js-submit-button');
                    if ($button.length) {
                        $button.on('click', function() {
                            $button.addClass('loading');
                        });
                    }
                }
            });
        });
    };

    PageOrder.prototype.__initReceiptModal = function () {
        var that = this;

        that.$wrapper.on('click', '.' + that.class.modal_receipt_details, function (e) {
            e.preventDefault();

            that.__showReceiptModal();
        });
    };

    PageOrder.prototype.__renderModal = function (type, options = {}) {
        const that = this;

        $.uiModal({
            html: that.modals[type],
            ...options
        });
    };

    PageOrder.prototype.__showReceiptModal = function () {
        var that = this;

        that.receipt_modal = $.uiModal({
            html: that.modals['receipt'],
            mobile_fullscreen: false,
            disable_content_scroll: true,
            onOpen: function ($modal_wrapper) {
                var $form = $modal_wrapper.find('.' + that.class.form_receipt_send),
                    $email_input = $modal_wrapper.find('.' + that.class.email);

                $email_input.focus();

                UIInputMask.prototype.initEmailMask($modal_wrapper);
                UIInputMask.prototype.initEmailValidate($modal_wrapper);

                $form.on('submit', function (e) {
                    e.preventDefault();
                    that.__receiptFormSubmit($modal_wrapper);
                });
            },
        });
    };

    PageOrder.prototype.__receiptFormSubmit = function ($wrapper) {
        var that = this,
            $send_button = $wrapper.find('.' + that.class.button_receipt_send),
            $email_input = $wrapper.find('.' + that.class.email),
            email = $.trim($email_input.val()),
            data = {email: email},

            receipt_send_url = that.order_passenger_hash ?
                $.sa.build_url('order/' + that.order_hash + '-' + that.order_passenger_hash) :
                $.sa.build_url('order/' + that.order_hash);

        receipt_send_url += '/receipt/send';

        if ($send_button.hasClass(that.class.loading)) {
            return false;
        }

        if (!$.sa.validate.email(email)) {
            return false;
        }

        $.sa.buttonLoading($send_button, true);

        $.post(receipt_send_url, data)
            .done(function (response) {
                if (response.status === 'ok') {
                    that.__handleReceiptSendSuccess(email);
                } else if (response.status === 'fail') {
                    that.__handleReceiptSendError();
                    $.sa.log(response);
                }
            })
            .fail(function () {
                that.__handleReceiptSendError();
            })
            .always(function () {
                $.sa.buttonLoading($send_button, false);
            });
    };

    PageOrder.prototype.__handleReceiptSendSuccess = function (confirmed_email) {
        var that = this;

        that.receipt_modal.close();

        setTimeout(function () {
            // receipt modal close timeout is 350ms.

            $.uiModal({
                html: that.modals['receipt_success'],
                mobile_fullscreen: false,
                disable_content_scroll: true,
                onOpen: function ($modal_wrapper) {
                    var $confirmed_email = $modal_wrapper.find('.' + that.class.confirmed_email);
                    $confirmed_email.text(confirmed_email);
                },
            });
        }, 400);
    };

    PageOrder.prototype.__handleReceiptSendError = function () {
        var that = this;

        that.receipt_modal.close();
        // receipt modal close timeout is 350ms.

        setTimeout(function () {
            $.uiModal({
                html: that.modals['receipt_error'],
                mobile_fullscreen: false,
                disable_content_scroll: true
            });
        }, 400);
    };

    return PageOrder;
})($);